"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _runtime = require("../runtime");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _default = (0, _runtime.IconWrapper)('orthopedic', function (props) {
  return _react.default.createElement("svg", {
    width: props.size,
    height: props.size,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, _react.default.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.0285 36L34.0028 42.9987V24C41.6771 18.7896 44.4962 13.9783 42.46 9.56594C39.4057 2.94746 34.4606 3.38382 31.007 5.00174C28.7046 6.08035 27.0356 9.09334 26 14.0407C22.9618 7.57467 18.6953 4.34165 13.2004 4.34165C4.95812 4.34165 4.29426 14.0648 5.47525 16.446C6.65624 18.8273 7.77303 20.1122 13.001 24C12.9258 35.5632 13.4064 41.7818 14.4428 42.6557C16.3437 44.1284 19.2056 41.9098 23.0285 36Z",
    fill: props.outFillColor,
    stroke: props.outStrokeColor,
    strokeWidth: props.strokeWidth,
    strokeLinejoin: props.strokeLinejoin
  }), _react.default.createElement("path", {
    d: "M27 25V31",
    stroke: props.innerStrokeColor,
    strokeWidth: props.strokeWidth,
    strokeLinecap: props.strokeLinecap
  }));
});

exports.default = _default;